import React, { Component } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import './ag-theme-ela.css';

import EditIcon from '../images/edit-icon.png';
import DeleteIcon from '../images/delete.png';

const moment = require('moment');

const DEFAULT_MIN_WIDTH_CELL = 10;
const DEFAULT_MAX_WIDTH_CELL = 800;

const defaultColDef = {
  resizable: true,
  sortable: true,
  filter: true,
  minWidth: DEFAULT_MIN_WIDTH_CELL,
  maxWidth: DEFAULT_MAX_WIDTH_CELL,
  cellStyle: {
    borderRight: '1px solid #ccc',
  },
};

class FileCellRenderer extends Component {
  render() {
    const { data, onDownload } = this.props;
    if (!data.fileName) return null;
    return (
      <span
        style={{ color: '#0d6efd', textDecoration: 'underline', cursor: 'pointer' }}
        onClick={() => onDownload(data)}
      >
        {data.fileName}
      </span>
    );
  }
}

class ActionsCellRenderer extends Component {
  render() {
    const { data, onEdit, onDelete } = this.props;
    return (
      <span>
        <img
          src={EditIcon}
          style={{ width: '14px', height: '14px', cursor: 'pointer', marginRight: '6px' }}
          onClick={() => onEdit(data)}
          alt="Edit"
        />
        <img
          src={DeleteIcon}
          style={{ width: '14px', height: '14px', cursor: 'pointer' }}
          onClick={() => onDelete(data)}
          alt="Delete"
        />
      </span>
    );
  }
}

export class TroubleTicketActionItemTableDefault extends Component {
  constructor(props) {
    super(props);
    this.gridApi = null;
    this.gridColumnApi = null;

    this.onGridReady = this.onGridReady.bind(this);
    this.adjustHeaderHeight = this.adjustHeaderHeight.bind(this);
    this.autoSizeUnspecifiedColumns = this.autoSizeUnspecifiedColumns.bind(this);
  }

  onGridReady = (params) => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.adjustHeaderHeight(params.api);
    this.autoSizeUnspecifiedColumns();
  };

  adjustHeaderHeight = (gridApi) => {
    window.requestAnimationFrame(() => {
      const allColumnHeaders = document.querySelectorAll('.ag-header-cell-text');
      let maxHeight = 0;
      allColumnHeaders.forEach((header) => {
        if (header.parentElement.clientHeight > maxHeight) {
          maxHeight = header.parentElement.clientHeight;
        }
      });
      gridApi.setHeaderHeight(maxHeight + 10);
    });
  };

  autoSizeUnspecifiedColumns = () => {
    if (!this.gridColumnApi) return;
    const allColumnIds = [];
    this.gridColumnApi.getColumns().forEach((column) => {
      if (column.getColDef().width === undefined) {
        allColumnIds.push(column.colId);
      }
    });
    if (allColumnIds.length > 0) {
      this.gridColumnApi.autoSizeColumns(allColumnIds, false);
    }
  };

  render() {
    const { actionItemList, onEdit, onDelete, onDownload } = this.props;

    const columnDefs = [
      { headerName: 'Description', field: 'troubleTicketActionItemDescription' },
      {
        headerName: 'File',
        field: 'fileName',
        width: 200,
        cellRenderer: FileCellRenderer,
        cellRendererParams: { onDownload },
      },
      {
        headerName: 'Created',
        field: 'createDateTime',
        width: 100,
        valueFormatter: (params) =>
          params.value ? moment(params.value).format('MM/DD/YYYY') : '',
      },
      {
        headerName: '',
        field: 'troubleTicketActionItemId',
        width: 60,
        sortable: false,
        filter: false,
        resizable: false,
        cellRenderer: ActionsCellRenderer,
        cellRendererParams: { onEdit, onDelete },
      },
    ];

    const gridOptions = {
      suppressSizeToFit: true,
      columnDefs,
      rowData: actionItemList,
      animateRows: true,
      defaultColDef,
      rowHeight: 20,
      tooltipShowDelay: 0,
      enableBrowserTooltips: true,
    };

    return (
      <div
        className="ag-theme-balham"
        style={{ width: '100%', height: `${Math.max(70, 28 + actionItemList.length * 20)}px` }}
      >
        <AgGridReact {...gridOptions} onGridReady={this.onGridReady} />
      </div>
    );
  }
}
